module.exports = __webpack_public_path__ + "img/uti_logo_blue.21635cd2.png";